/*jshint esversion: 6 */
/*jshint sub:true*/
import { mapGetters, mapActions, mapState } from 'vuex';

import draggable from "vuedraggable";
import pdf from 'vue-pdf';

import TTabsLayout from '@/components/Taktify/TTabsLayout.component.vue';

import ProjectStructure from '@/components/ProjectStructure/ProjectStructure.component.vue';
import ProjectStructureDetails from '@/components/ProjectStructure/ProjectStructureDetails.component.vue';
import ProjectStructureTree from '@/components/ProjectStructure/ProjectStructureTree.component.vue';
import ProjectStructureTrain from '@/components/ProjectStructure/ProjectStructureTrain.component.vue';
import ProjectStructureTaktarea from '@/components/ProjectStructure/ProjectStructureTaktarea.component.vue';
import ProjectStructureTaktareaWrapper from '@/components/ProjectStructure/ProjectStructureTaktareaWrapper.component.vue';
import ProjectStructureTaktareaElement from '@/components/ProjectStructure/ProjectStructureTaktareaElement.component.vue';
import ProjectStructureTaktTimeSelector from '@/components/ProjectStructure/ProjectStructureTaktTimeSelector.component.vue';
import ProjectStructureShape from '@/components/ProjectStructure/ProjectStructureShape.component.vue';

import ProjectStructureBuildingModel from '@/components/ProjectStructure/ProjectStructureBuildingModel.component.vue';
import ProjectStructureBuildingModelNew from '@/components/ProjectStructure/ProjectStructureBuildingModelNew.component.vue';

import ProjectStructureWidget from '@/components/ProjectStructure/ProjectStructureWidget.component.vue';
import ProjectStructureWidgetOverlay from '@/components/ProjectStructure/ProjectStructureWidgetOverlay.component.vue';
import ProjectStructurePlanPoint from '@/components/ProjectStructure/ProjectStructurePlanPoint.component.vue';
import ProjectStructurePlanEdgePoint from '@/components/ProjectStructure/ProjectStructurePlanEdgePoint.component.vue';
import StepMatrixHeader from '@/components/ProjectStructure/StepMatrixHeader.component.vue';
import StepMatrixBody from '@/components/ProjectStructure/StepMatrixBody.component.vue';

import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import StandardDialogFullScreen from '@/components/StandardComponents/StandardDialogFullScreen.component.vue';
import StandardDeleteButtonLarge from '@/components/StandardComponents/StandardDeleteButtonLarge.component.vue';
import StandardDeleteButton from '@/components/StandardComponents/StandardDeleteButton.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';

import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';

import TFinderLayout from '@/components/Taktify/TFinderLayout.component.vue';
import TFlex from '@/components/Taktify/TFlex.component.vue';
import TProgressBar from '@/components/Taktify/TProgressBar.component.vue';

import ActivatorSlider from '@/components/ProjectTaktPlan/ActivatorSlider.component.vue';



export const ProjectStructureMixin = {
  components: {
    draggable,
    pdf,

    TTabsLayout,

    ProjectStructure,
    ProjectStructureDetails,
    ProjectStructureTree,
    ProjectStructureTrain,
    ProjectStructureTaktarea,
    ProjectStructureTaktareaWrapper,
    ProjectStructureTaktareaElement,
    ProjectStructureTaktTimeSelector,
    ProjectStructureShape,

    ProjectStructureBuildingModel,
    ProjectStructureBuildingModelNew,

    ProjectStructureWidget,
    ProjectStructureWidgetOverlay,
    ProjectStructurePlanPoint,
    ProjectStructurePlanEdgePoint,
    StepMatrixHeader,
    StepMatrixBody,

    StandardDataField,
    StandardDialog,
    StandardDialogFullScreen,
    StandardDeleteButtonLarge,
    StandardDeleteButton,
    Waggon,
    WorkPackage,
    StandardBadge,

    TFinderLayout,
    TFlex,
    TProgressBar,

    ActivatorSlider
  },
  data: () => ({
    tabs: [
      {name: 'Spatial Structure', identifier: 'spatialstructure', show: true, initial_width_factor: 1, color_body: 'rgb(41,41,41)'},
      {name: 'Building Model', identifier: 'buildingmodel', show: true, initial_width_factor: 3, color_body: false},
      {name: 'Process Structure', identifier: 'processtructure', show: true, initial_width_factor: 1, color_body: 'rgb(41,41,41)'},
      // {name: 'asdf Structure', identifier: 'test', show: true, initial_width_factor: 1},
    ],
    ifc_entities: {
      sites: {id: -1, type: 'sites', name: 'Site', description: '', order_index: 0, closed: false, plans: [], sites: [], buildings: [], spatialzones: [], elements: []},
      spatialzones: {id: -1, type: 'spatialzones', name: 'Zone', description: '', order_index: 0, closed: false, plans: [], spatialzones: [], elements: []},
      buildings: {id: -1, type: 'buildings', name: 'Building', description: '', order_index: 0, closed: false, plans: [], buildings: [], buildingstoreys: [], spacegroups: [], elements: []},
      buildingstoreys: {id: -1, type: 'buildingstoreys', name: 'Storey', description: '', order_index: 0, closed: false, plans: [], buildingstoreys: [], spacegroups: [], elements: []},
      spacegroups: {id: -1, type: 'spacegroups', name: 'Space Group', description: '', order_index: 0, closed: false, plans: [], spacegroups: [], elements: []},
      elements: {id: -1, type: 'elements', name: 'Element', description: '', order_index: 0, order_index_ta: 0, ifc_type: 'IFCBUILDINGELEMENTPROXY'},
    },
    spatial_containers: [
      {id: -1, type: 'sites', name: 'Site', description: '', order_index: 0, closed: false, plans: [], sites: [], buildings: [], spatialzones: [], elements: []},
      {id: -1, type: 'spatialzones', name: 'Zone', description: '', order_index: 0, closed: false, plans: [], spatialzones: [], elements: []},
      {id: -1, type: 'buildings', name: 'Building', description: '', order_index: 0, closed: false, plans: [], buildings: [], buildingstoreys: [], spacegroups: [], elements: []},
      {id: -1, type: 'buildingstoreys', name: 'Storey', description: '', order_index: 0, closed: false, plans: [], buildingstoreys: [], spacegroups: [], elements: []},
      {id: -1, type: 'spacegroups', name: 'Space Group', description: '', order_index: 0, closed: false, plans: [], spacegroups: [], elements: []},
    ],
    spatial_elements: [
      {
        id: -1,
        type: 'elements',
        name: 'Space',
        element_type: 'spaces',
        description: '',
        order_index: 0,
        order_index_ta: 0,
        paths: [],
        ref_point: {x: 0, y: 0, z: 0},
        height: 2.5,
        floor_area: 0,
        perimeter: 0,
        visible: true
      },
    ],
    process_structure_elements: [
      {id: -1, type: 'trains', name: 'Train'},
      {id: -1, type: 'taktareas', name: 'Taktarea'},
    ],
    manage_floor_plan: false,
    manage_location: false,
    manage_workpackages: false,
    select_spatial_el_ta_id: -1,
    select_spatial_el_train_id: -1,

    dragging: false,

    //hovering Train
    hover_train_id: -1,
    hover_timer_train: 2,
    interval_train: '',
    hover_timer_train_id_cache: -1,

    //hovering TA
    hover_ta_id: -1,
    hover_timer: 2,
    interval: '',
    hover_timer_id_cache: -1,

    //hover element
    hover_el_ids: [],
    hover_el_timer: 2,
    interval_el: '',
    hover_el_timer_id_cache: -1,

    //selected element
    selected_tree_element: {
      type: 'elements',
      id: -1,
    },

    //step matrix
    step_matrix_wp_id: false,
    step_matrix_ta_id: false,
    //ifc import;
    show_ifc_error: false,
    ifc_error: [],
    ifc_class_helper: {
      'IFCPROJECT': {entity: 'projects', sites: [], elements: []},
      'IFCSITE': {entity: 'sites', sites: [], buildings: [], spatialzones: [], elements: []},
      'IFCSPATIALZONE': {entity: 'spatialzones', spatialzones: [], elements: []},
      'IFCBUILDING': {entity: 'buildings', buildings: [], buildingstoreys: [], spacegroups: [], elements: []},
      'IFCBUILDINGSTOREY': {entity: 'buildingstoreys', buildingstoreys: [], spacegroups: [], elements: []},
      'IFCSPACECOMPLEX': {entity: 'spacegroups', spacegroups: [], elements: []},
      'IFCSPACEELEMENT': {entity: 'elements', element_type: 'spaces'}
    },
    //icfimport
    importing_ifc: {
      importing: false,
      ifc_size: 1,
    },
  }),
  computed: {
    ...mapGetters('Auth', [
      'hasPermission'
    ]),
    ...mapGetters('Ultra', [
      'getUObject',
      'getUObjects',
      'getUObjectsFiltered'
    ]),
    ...mapGetters('UltraDev', [
      'getUDObject',
      'getUDObjects',
      'getUDObjectsFiltered'
    ]),
    ...mapGetters('ProjectStructure', [
      'getChildElements',
      'getAllChildElements',
      'getParentsFloorPlans',
      'getSpatialUnitsLocation',
      'getAllSpatialUnitsWorkpackageIds',
      'getAllSelectedElements',
      'getVisibility'
    ]),
    ...mapGetters('Project', [
      'isEditMode'
    ]),
    ...mapState('SnackBarIFC', [
      'snackbar'
    ]),
    selected_tree_element_children() {
      if (this.selected_tree_element.id !== -1 && this.selected_tree_element.type !== 'elements') {
        if (this.selected_tree_element.type === 'element_wrapper') {
          return this.selected_tree_element.elements;
        } else {
          return this.getAllChildElements({parent_type: this.selected_tree_element.type, parent_id: this.selected_tree_element.id});
        }
      } else {
        return [];
      }
    }
  },
  watch: {
    // hover_el_ids: function(val) {
    //   console.log(val);
    // },
    isEditMode: function(val) {
      if (!val) {
        this.select_spatial_el_ta_id = -1;
        this.select_spatial_el_train_id = -1;
      }
    },
    $route: function () {
      if (this.element) {
        if (this.element.type === 'elements' && this.element.locations.length !== 0) {
          let locations = this.getUDObjects({type: 'locations', ids: this.element.locations});
          let plan = this.getUDObject({type: 'plans', id: locations[0].plan_id});
          this.renderPlanDetailsPDF(plan.plan_url, 'plan_details_pdf');
          this.updatePlanDetailsCanvas(locations, 'plan_details_canvas', 'plan_details_pdf');
        } else if (this.element.plans.length !== 0){
          let plan = this.getUDObject({type: 'plans', id: this.element.plans[0]});
          let locations = this.getUDObjectsFiltered({type: 'locations', filter: {plan_id: plan.id}});
          this.renderPlanDetailsPDF(plan.plan_url, 'plan_details_floor_plan_pdf');
          this.updatePlanDetailsCanvas(locations, 'plan_details_floor_plan_canvas', 'plan_details_floor_plan_pdf');
        }
      }
    },
  },
  methods: {
    selectAllSpatialContainerElements(elements) {
      let add_elements = [];
      let remove_elements = [];
      elements.forEach(id => {
        if (!this.getAllSelectedElements({projet_id: this.project_id, train_id: this.select_spatial_el_train_id}).includes(parseInt(id))) {
          add_elements.push(parseInt(id));
        } else {
          remove_elements.push(parseInt(id));
        }
      });
      if (add_elements.length === 0) {
        // let remove_elements = JSON.parse(JSON.stringify(this.getUObject({type: 'taktareas', id: this.select_spatial_el_ta_id}).elements));
        this.removeUObjects({
            url: [
              {projects: this.project_id},
              {trains: 0},
              {taktareas: this.select_spatial_el_ta_id},
              {remove: ''}
            ],
            u_objects: {
              target_type: 'elements',
              target_ids: remove_elements
            }
          }).then(() => {
            this.updateCanvas();
          });
      } else {
        this.addUObjects({
            url: [
              {projects: this.project_id},
              {trains: 0},
              {taktareas: this.select_spatial_el_ta_id},
              {add: ''}
            ],
            u_objects: {
              target_type: 'elements',
              target_ids: add_elements
            }
          }).then(() => {
            this.updateCanvas();
          });
      }
    },
    taMouseEnter(taktarea) {
      this.hover_timer = 2;
      this.interval = setInterval(this.checkTimer, 50);
      this.hover_timer_id_cache = taktarea.id;
    },
    taMouseLeave() {
      clearInterval(this.interval);
      this.hover_ta_id = -1;
    },
    checkTimer() {
      if (this.hover_timer < 1) {
        clearInterval(this.interval);
        this.hover_ta_id = this.hover_timer_id_cache;
      } else {
        this.hover_timer--;
      }
    },
    trainMouseEnter(train_id) {
      this.hover_timer_train = 2;
      this.interval_train = setInterval(this.checkTimerTrain, 50);
      this.hover_timer_train_id_cache = train_id;
    },
    trainMouseLeave() {
      clearInterval(this.interval_train);
      this.hover_train_id = -1;
    },
    checkTimerTrain() {
      if (this.hover_timer_train < 1) {
        clearInterval(this.interval_train);
        this.hover_train_id = this.hover_timer_train_id_cache;
      } else {
        this.hover_timer_train--;
      }
    },
    elMouseEnter(evt) {
      this.hover_el_timer = 2;
      clearInterval(this.interval_el);
      this.interval_el = setInterval(this.elCheckTimer, 50);
      if (evt.type === 'elements') {
        this.hover_el_timer_id_cache = [parseInt(evt.id)];
      } else if (evt.type === 'element_wrapper') {
        this.hover_el_timer_id_cache = evt.element_ids;
      } else {
        this.hover_el_timer_id_cache = this.getAllChildElements({parent_type: evt.type, parent_id: evt.id});
      }
    },
    elMouseLeave() {
      clearInterval(this.interval_el);
      // if (evt.type === 'sites') {
        this.hover_el_ids = [];
      // }
    },
    elCheckTimer() {
      if (this.hover_el_timer < 1) {
        clearInterval(this.interval_el);
        this.hover_el_ids = this.hover_el_timer_id_cache;
      } else {
        this.hover_el_timer--;
      }
    },
    ...mapActions('UltraDev', [
      'createUDObject',
      'updateUDObject',
      'deleteUDObject',
      'changeUDObjectParent',
      'addUDObjects',
      'removeUDObjects',
    ]),
    ...mapActions('Ultra', [
      'requestUObject',
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'updateUObjectParent',
      'updateUObjectPosition',
      'updateUObjectRelations',
      'addUObjects',
      'removeUObjects',
    ]),
    ...mapActions('Project', [
      'enterEditMode',
      'leaveEditMode'
    ]),
    ...mapActions('ProjectStructure', [
      'removeElementsFromTaktareas',
      'toggleVisibility',
      'togglePropSet',
      'toggleElementWrappersOpen',
      'importIFCNew',
      'requestProjectElements'
    ]),
    ...mapActions('SnackBarIFC', [
      'requestSnackbarUpdateRelations',
      'updateSnackbar',
      'applySnackbar',
    ]),
    testzeit() {
      console.log('startzeit');
    },
    toggleAllTaktareas(train) {
      let closed = JSON.parse(JSON.stringify(this.getUObject({type: 'taktareas', id: train.taktareas[0]}).closed));
      let bulk = {
        updates: [],
        targets: {taktareas: train.taktareas},
      };
      train.taktareas.forEach(() => {
        bulk.updates.push({
          closed: !closed
        });
      });
      this.updateUDObject({
        url: [
          {taktareas: train.taktareas[0]},
          {'updatebulk': ''}
        ],
        bulk: bulk
      });
    },
    selectFloorPlan(plan) {
      if (this.element.plans.length === 0) {
      this.createUDObject({
        url: [
          {[this.element.type]: this.element.id},
          {plans: ''},
          {showWithEntitiesNormalized: ''}
        ],
        resp_data: {
          plans: [
            {
              id: -1,
              name: 'New FloorPlan',
              plan_url: '',
              reference_x: 25,
              reference_y: 25,
              scale_x_1: 75,
              scale_y_1: 25,
              scale_x_2: 275,
              scale_y_2: 25,
              pixcel_per_length: 20,
            }
          ]
        }
      }).then((id) => {
        this.updateUDObject({
            url: [
              {'plans': id},
            ],
            update: {
              plan_url: URL.createObjectURL(plan)
            }
          }).then(() => {
          this.$router.push({
              name: 'ProjectStructurePlans',
              params: {
                plan_id: id
              }
            });
        });
      });
    } else {
      //replace floor plan
      this.updateUDObject({
          url: [
            {'plans': this.element.plans[0]},
          ],
          update: {
            plan_url: URL.createObjectURL(plan)
          }
        }).then(() => {
        this.$router.push({
            name: 'ProjectStructurePlans',
            params: {
              plan_id: this.element.plans[0]
            }
          });
      });
    }
    },
    deleteFloorPlanLocations(plan_id) {
      return new Promise((resolve) => {
          let locations = this.getUDObjectsFiltered({type: 'locations', filter: {plan_id: plan_id}});
          locations.forEach(location => {
            this.deleteUDObject({
              url: [
                {locations: location.id}
              ]
            });
          });
          resolve();
      });
    },
    getElementsIcon(type) {
      let icon = '';
      switch (type) {
        case 'sites':
          icon = 'select_all';
          break;
        case 'spatialzones':
          icon = 'schema';
          break;
        case 'buildings':
          icon = 'domain';
          break;
        case 'buildingstoreys':
          icon = 'format_line_spacing';
          break;
        case 'spacegroups':
          icon = 'crop_free';
          break;
        case 'elements':
          icon = 'list_alt';
          break;
        case 'plans':
          icon = 'picture_as_pdf';
          break;
      }
      return icon;
    },
    updateTreeOrderIndex(parent) {
      let child_elements;
      if (parent.type === 'element_wrapper') {
        child_elements = JSON.parse(JSON.stringify(parent.elements));
      } else {
        child_elements = JSON.parse(JSON.stringify(this.getChildElements({parent_type: parent.type, parent_id: parent.id})));
      }
      let child_elements_sorted = child_elements.sort(function (a,b) {
        return a.order_index - b.order_index;
      });
      let bulk_calls = {};
      child_elements_sorted.forEach((element, index) => {
        if (element.type !== 'element_wrapper') {
          if (bulk_calls[element.type]) {
            bulk_calls[element.type].targets.push(element.id);
            bulk_calls[element.type].updates.push({order_index: (index + 1) * 10});
          } else {
            bulk_calls[element.type] = {
              targets: [element.id],
              updates: [{order_index: (index + 1) * 10}]
            };
          }
          // this.updateUObject({
          //   url: [
          //     {[element.type]: element.id}
          //   ],
          //   url_prefix: `/projects/${this.project_id}/projectstructure`,
          //   update: {
          //     order_index: (index + 1) * 10
          //   }
          // });
        }
      });
      for(let element_type in bulk_calls) {
        this.updateUObject({
          url: [
            {[element_type]: 0},
            { 'updatebulk': '' }
          ],
          url_prefix: `/projects/${this.project_id}/projectstructure`,
          bulk: {
            targets: {[element_type]: bulk_calls[element_type].targets},
            updates: bulk_calls[element_type].updates,
          }
        });
      }
    },
    renderPlanDetailsPDF(url, canvas_id) {
      // if (!this.pdf_rendering) {
        this.pdf_rendering = true;
        let self = this;
        let loading_task = pdf.createLoadingTask(url);
        // Asynchronous download PDF
        loading_task.promise.then(function(pdf) {
          return pdf.getPage(1);
        }).then(function(page) {

          let viewport = page.getViewport({scale: 0.3});

          // Get canvas#the-canvas
          let canvas = document.getElementById(canvas_id);

          // Fetch canvas' 2d context
          let context = canvas.getContext('2d');

          // Set dimensions to Canvas
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          let ratio = viewport.height / viewport.width;

          let body_width = document.getElementById('project-structure-widget-body').scrollWidth;
          let body_height = document.getElementById('project-structure-widget-body').scrollHeight;

          if (body_width * ratio <= body_height) {
            canvas.style.width = `${body_width}px`;
            canvas.style.height = `${body_width * ratio}px`;
          } else {
            canvas.style.width = `${body_height / ratio}px`;
            canvas.style.height = `${body_height}px`;
          }


          // Prepare object needed by render method
          let renderContext = {
            canvasContext: context,
            viewport: viewport
          };

          // Render PDF page
          let renderTask = page.render(renderContext);
          renderTask.promise.then(function () {
            self.pdf_rendering = false;
          });
        });
      // }
    },
    updatePlanDetailsCanvas(locations, canvas_id, pdf_canvas_id) {
      setTimeout(function () {

        let canvas = document.getElementById(canvas_id);
        let ctx = canvas.getContext('2d');


        let canvas_width = document.getElementById(pdf_canvas_id).scrollWidth;
        let canvas_height = document.getElementById(pdf_canvas_id).scrollHeight;

        canvas.width = canvas_width;
        canvas.height = canvas_height;

        let factor = canvas_width / 1000;

        canvas.style.width = `${canvas_width}px`;
        canvas.style.height = `${canvas_height}px`;


        ctx.clearRect(0,0, canvas_width, canvas_height);
        ctx.fillStyle = 'rgba(76,175,80,0.3)';

        locations.forEach(location => {
          ctx.beginPath();
          ctx.moveTo(location.path.points[0].x * factor, location.path.points[0].y * factor);
          for (var i = 1; i < location.path.points.length; i++) {
            ctx.lineTo(location.path.points[i].x * factor, location.path.points[i].y * factor);
          }
          ctx.closePath();
          ctx.fill();
          ctx.stroke();
        });
      }, 100);
    },
    selectIFC(ifc) {
      var fileReader = new FileReader();
      let self = this;
      fileReader.onload = function (e) {

          let ifc_lines = e.target.result.split(/;\r\n|;\n/);
          // let ifc_data = [];
          let ifc_data_object = {};
          let ifc_relations = [];
          // let ifc_elements = [];

          let ifc_property_relations = {};

          let ifc_local_placements = {};
          let ifc_local_placement_ids = [];
          let ifc_local_placement_repeat_ids = [];

          let ifc_project_ids = [];

          ifc_lines.forEach(line => {
            if (line.substring(0,1) === '#') {

              let line_helper = line.split(/= /);

              //delete line breaks
              line_helper[1] = line_helper[1].replace(/(?:\r\n|\r|\n)/g, '');

              let line_helper_two = line_helper[1].split(',');
              line_helper_two.splice(0,1, line_helper_two[0].split(/(?<!\()\(/)[0], line_helper_two[0].split(/(?<!\()\(/)[1]);

              line_helper_two[line_helper_two.length-1] = line_helper_two[line_helper_two.length-1].substring(0, line_helper_two[line_helper_two.length-1].length-1);

              //combine brackets to arrays
              let line_helper_three = [];
              let in_brackets = false;
              let bracket_array = [];
              line_helper_two.forEach(attr => {
                if (attr.substring(0,1) === '(') {
                  in_brackets = true;
                  attr = attr.substring(1);
                }
                if (!in_brackets) {
                  line_helper_three.push(attr);
                } else {
                  bracket_array.push(attr);
                }
                if (attr.substring(attr.length-1) === ')' && in_brackets) {
                  in_brackets = false;
                  bracket_array[bracket_array.length-1] = bracket_array[bracket_array.length-1].substring(0, bracket_array[bracket_array.length-1].length-1);
                  line_helper_three.push(bracket_array);
                  bracket_array = [];
                }
              });
              let line_ifc_id = line_helper[0];
              let line_class = line_helper_three.splice(0,1)[0];
              let line_attributes = line_helper_three;

              let class_helper = {};
              //extend only supported classes
              if ([
                'IFCPROJECT',
                'IFCSITE',
                'IFCSPATIALZONE',
                'IFCBUILDING',
                'IFCBUILDINGSTOREY',
                'IFCSPACE',
              ].includes(line_class)) {
                if (line_class === 'IFCSPACE' && line_attributes[8].includes('COMPLEX')) {
                  class_helper = JSON.parse(JSON.stringify(self.ifc_class_helper['IFCSPACECOMPLEX']));
                } else if (line_class === 'IFCSPACE' && line_attributes[8].includes('ELEMENT') || line_attributes[8] === '$') {
                  class_helper = JSON.parse(JSON.stringify(self.ifc_class_helper['IFCSPACEELEMENT']));
                } else {
                  class_helper = JSON.parse(JSON.stringify(self.ifc_class_helper[line_class]));
                }
                class_helper.name = line_attributes[2]?line_attributes[2].substring(1, line_attributes[2].length-1):'';
              }

              // ifc_data.push(
              //   Object.assign(
              //   {
              //     ifc_id: line_ifc_id,
              //     class: line_class,
              //     attributes: line_attributes,
              //   },
              //   class_helper
              // ));
              ifc_data_object[line_ifc_id] = Object.assign(
                {
                  ifc_id: line_ifc_id,
                  class: line_class,
                  attributes: line_attributes,
                },
                class_helper
              );
              //set project id
              if (line_class === 'IFCPROJECT') {
                ifc_project_ids.push(line_ifc_id);
              }
              //relations
              if (line_class === 'IFCRELAGGREGATES') {
                ifc_relations.push({
                  ifc_id: line_ifc_id,
                  class: line_class,
                  attributes: line_attributes,
                });
              }
              //local palcement ids
              if (line_class === 'IFCLOCALPLACEMENT') {
                ifc_local_placement_ids.push({
                  ifc_id: line_ifc_id,
                  class: line_class,
                  attributes: line_attributes,
                });
              }
              //properties
              if (line_class === 'IFCRELDEFINESBYPROPERTIES') {
                line_attributes[4].forEach(id => {
                  if (ifc_property_relations[id]) {
                    ifc_property_relations[id].push({
                      ifc_id: line_ifc_id,
                      class: line_class,
                      attributes: line_attributes,
                    });
                  } else {
                    ifc_property_relations[id] = [{
                      ifc_id: line_ifc_id,
                      class: line_class,
                      attributes: line_attributes,
                    }];
                  }
                });
              }

              // //elements
              // if (['IFCSPACE'].includes(line_class) && ((line_class === 'IFCSPACE' && line_attributes[8].includes('ELEMENT')) || line_class !== 'IFCSPACE')) {
              //   ifc_elements.push({
              //     ifc_id: line_ifc_id,
              //     class: line_class,
              //     attributes: line_attributes,
              //   });
              // }
            }
          // }
          });
          //set local matrix
          ifc_local_placement_ids.forEach(id => {
            //set local matrix
            ifc_local_placements[id.ifc_id] = self.getLocalPlacementMatrices({ifc_data_object: ifc_data_object, attributes: id.attributes, ifc_local_placements: ifc_local_placements});
            let placement = ifc_local_placements[id.ifc_id];
            //set trans matrix
            if (placement.parent_placement_id === '$') {
              placement.trans_matrix = placement.local_matrix;
            }
            //set trans matrix with parent trans matrix
            else if (ifc_local_placements[placement.parent_placement_id] && ifc_local_placements[placement.parent_placement_id].trans_matrix.length !== 0) {
              // let parent_local_matrix = ifc_local_placements[placement.parent_placement_id].local_matrix;
              let parent_trans_matrix = ifc_local_placements[placement.parent_placement_id].trans_matrix;
              // placement.trans_matrix = self.$math.multiply(placement.local_matrix, self.$math.inv(parent_local_matrix));

              placement.trans_matrix = self.$math.multiply(self.$math.inv(parent_trans_matrix), placement.local_matrix);

              placement.trans_matrix_copy = JSON.parse(JSON.stringify(placement.trans_matrix));

              let cartesian_point = self.$math.multiply(placement.local_matrix[3], parent_trans_matrix);
              placement.test_ref_point = cartesian_point;
              placement.trans_matrix.splice(3, 1, cartesian_point);


              // placement.trans_matrix[3].forEach((val, index) => {
              //   if (index !== placement.trans_matrix[3].length-1) {
              //     placement.trans_matrix[3].splice(index, 1, val * -1);
              //   }
              // });

              let ref_point = [0,0,0,1];
              placement.ref_point = self.$math.multiply(ref_point, placement.trans_matrix);
              let ref_point_1 = [1,1,0,1];
              placement.ref_point_1 = self.$math.multiply(ref_point_1, placement.trans_matrix);
            }
            else {
              if (ifc_local_placement_repeat_ids.indexOf(placement.parent_placement_id) === -1) {
                ifc_local_placement_repeat_ids.push(placement.parent_placement_id);
              }
              if (ifc_local_placement_repeat_ids.indexOf(id.idc_id) === -1) {
                ifc_local_placement_repeat_ids.push(id.ifc_id);
              }
            }
          });

          let boolean = true;
          let length = ifc_local_placement_repeat_ids.length;
          while (boolean) {
          length = ifc_local_placement_repeat_ids.length;
          ifc_local_placement_repeat_ids.forEach((id, index) => {
            let placement = ifc_local_placements[id];
            if (placement.trans_matrix.length === 0) {
              // let parent_local_matrix = ifc_local_placements[placement.parent_placement_id].local_matrix;
              let parent_trans_matrix = ifc_local_placements[placement.parent_placement_id].trans_matrix;
              // placement.trans_matrix = self.$math.multiply(placement.local_matrix, self.$math.inv(parent_local_matrix));

              if (parent_trans_matrix.length !== 0) {

                placement.trans_matrix = self.$math.multiply(self.$math.inv(parent_trans_matrix), placement.local_matrix);

                placement.trans_matrix_copy = JSON.parse(JSON.stringify(placement.trans_matrix));

                let cartesian_point = self.$math.multiply(placement.local_matrix[3], parent_trans_matrix);
                placement.test_ref_point = cartesian_point;
                placement.trans_matrix.splice(3, 1, cartesian_point);


                // placement.trans_matrix[3].forEach((val, index) => {
                //   if (index !== placement.trans_matrix[3].length-1) {
                //     placement.trans_matrix[3].splice(index, 1, val * -1);
                //   }
                // });

                let ref_point = [0,0,0,1];
                placement.ref_point = self.$math.multiply(ref_point, placement.trans_matrix);
                let ref_point_1 = [1,1,0,1];
                placement.ref_point_1 = self.$math.multiply(ref_point_1, placement.trans_matrix);

                ifc_local_placement_repeat_ids.splice(index, 1);
              }
            }
          });
          if (ifc_local_placement_repeat_ids.length === length) {
            boolean = false;
          }
          }
          // set trans matrix
          // Object.values(ifc_local_placements).forEach(value => {
          //   if (value.parent_placement_id === '$') {
          //     value.trans_matrix = value.local_matrix;
          //   } else {
          //     // let parent_local_matrix = ifc_local_placements[value.parent_placement_id].local_matrix;
          //     let parent_trans_matrix = ifc_local_placements[value.parent_placement_id].trans_matrix;
          //     // value.trans_matrix = self.$math.multiply(value.local_matrix, self.$math.inv(parent_local_matrix));
          //     value.trans_matrix = self.$math.multiply(self.$math.inv(parent_trans_matrix), value.local_matrix);
          //
          //     value.trans_matrix_copy = JSON.parse(JSON.stringify(value.trans_matrix));
          //
          //     let cartesian_point = self.$math.multiply(value.local_matrix[3], parent_trans_matrix);
          //     value.test_ref_point = cartesian_point;
          //     value.trans_matrix.splice(3, 1, cartesian_point);
          //
          //
          //     // value.trans_matrix[3].forEach((val, index) => {
          //     //   if (index !== value.trans_matrix[3].length-1) {
          //     //     value.trans_matrix[3].splice(index, 1, val * -1);
          //     //   }
          //     // });
          //
          //     let ref_point = [0,0,0,1];
          //     value.ref_point = self.$math.multiply(ref_point, value.trans_matrix);
          //     let ref_point_1 = [1,1,0,1];
          //     value.ref_point_1 = self.$math.multiply(ref_point_1, value.trans_matrix);
          //   }
          // });


          //set relations
          let error = [];
          ifc_relations.forEach(rel => {
            rel.attributes[5].forEach(child_id => {
              let child = ifc_data_object[child_id];
              //only supported classes
              if ([
                'IFCPROJECT',
                'IFCSITE',
                'IFCSPATIALZONE',
                'IFCBUILDING',
                'IFCBUILDINGSTOREY',
                'IFCSPACE',
              ].includes(child.class)) {
                let parent = ifc_data_object[rel.attributes[4]];
                if (parent[child.entity]) {
                  parent[child.entity].push(child_id);

                } else {
                  error.push({
                    parent: parent,
                    child: child,
                  });
                }
              }
            });
          });
          if (error.length !== 0) {
            self.show_ifc_error = true;
            self.ifc_error = error;
          }
          else {
            ifc_project_ids.forEach((project_id) => {
              let project = ifc_data_object[project_id];
            //sites
            project.sites.forEach(site_id => {
              self.createIFCObjects({
                parent_type: 'projects',
                parent_id: self.project_id,
                child_type: 'sites',
                child_id: site_id,
                ifc_data_object: ifc_data_object,
                ifc_local_placements: ifc_local_placements,
                ifc_property_relations: ifc_property_relations
              });
            });

          });
          }

      };
      fileReader.readAsText(ifc);
    },
    createIFCObjects(payload) {
      let object = payload.ifc_data_object[payload.child_id];
      this.createUObject({
        url: [
          {[payload.parent_type]: payload.parent_id},
          {[payload.child_type]: ''},
          {showWithEntitiesNormalized: ''}
        ],
        url_prefix: `/projects/${this.project_id}/projectstructure`,
        u_object: JSON.parse(JSON.stringify(Object.assign(JSON.parse(JSON.stringify(this.spatial_containers.find(el => el.type === payload.child_type))), {name: object.name, order_index: 5, parent: {type: payload.parent_type, id: payload.parent_id}}))),
      }).then(object_id => {
        //elements
        object.elements.forEach(element_id => {
          let element = payload.ifc_data_object[element_id];

          this.createUObject({
            url: [
              {[payload.child_type]: object_id},
              {elements: ''},
              {showWithEntitiesNormalized: ''}
            ],
            url_prefix: `/projects/${this.project_id}/projectstructure`,
            u_object: JSON.parse(JSON.stringify(Object.assign(JSON.parse(JSON.stringify(this.spatial_elements.find(el => el.element_type === element.element_type))), {name: element.name, description: element.attributes[7].split("'")[1], order_index: 5, parent: {type: payload.child_type, id: object_id}}))),
          }).then(id => {
            //create elements path
            let product_definition_shape = payload.ifc_data_object[element.attributes[6]];
            let shape_representations = product_definition_shape.attributes[2].map(id => payload.ifc_data_object[id]);

            shape_representations.forEach(rep => {
              rep.paths = this.ifc_create_path({
                rep,
                ifc_data_object: payload.ifc_data_object,
                trans_matrix: payload.ifc_local_placements[element.attributes[5]].trans_matrix,
                local_matrix: payload.ifc_local_placements[element.attributes[5]].local_matrix,
              });
            });
            let index = -1;
            //Footprint
            index = shape_representations.findIndex(rep => rep.attributes[1] === "'FootPrint'" && rep.paths.length !== 0);
            if (index === -1) {
              index = shape_representations.findIndex(rep => rep.attributes[1] === "'Body'" && rep.attributes[2] === "'SweptSolid'" && rep.paths.length !== 0);
            } else if (index === -1) {
              index = shape_representations.findIndex(rep => rep.attributes[1] === "'Box'" && rep.paths.length !== 0);
            }
            if (index !== -1) {
              let paths = shape_representations[index].paths;
              let floor_area = this.calcPolygonArea(paths[0].points);
              let perimeter = this.calcPolygonPerimeter(paths[0].points);
              this.updateUDObject({
                url: [
                  {elements: id}
                ],
                update: {
                  paths: paths,
                  floor_area: floor_area,
                  perimeter: perimeter,
                }
              });
            }
            //Body && SweptSolid
            //Box


            let prop_sets = [];

            if (payload.ifc_property_relations[element_id]) {
              payload.ifc_property_relations[element_id].forEach(prop_rel => {
                let new_prop_set = {};
                let prop_set = payload.ifc_data_object[prop_rel.attributes[5]];
                new_prop_set.name = prop_set.attributes[2].split("'")[1];
                new_prop_set.closed = true;
                new_prop_set.props = [];

                let props = [];
                if (prop_set.class === 'IFCELEMENTQUANTITY') {
                  props = prop_set.attributes[5].map(id => payload.ifc_data_object[id]);
                } else {
                  props = prop_set.attributes[4].map(id => payload.ifc_data_object[id]);
                }

                props.forEach(prop => {
                  let key = '';
                  let value = '';
                  if (prop.class === 'IFCPROPERTYSINGLEVALUE') {
                    key = prop.attributes[0].split("'")[1];
                    if (prop.attributes[2].includes('IFCTEXT') || prop.attributes[2].includes('IFCLABEL')) {
                      value = prop.attributes[2].split("'")[1];
                    } else if (prop.attributes[2].includes('IFCBOOLEAN')) {
                      let boolean = prop.attributes[2].split(".")[1];
                      if (boolean === 'F') {
                        value = false;
                      } else {
                        value = true;
                      }
                    }
                  } else if (prop.class.includes('IFCQUANTITY')) {
                    key = prop.attributes[0].split("'")[1];
                    value = prop.attributes[3];
                  }
                  if (key !== '') {
                    new_prop_set.props.push({key: key, value: value});
                  }
                });
                prop_sets.push(new_prop_set);
              });
            }
            if (prop_sets.length !== 0) {
              this.updateUDObject({
                url: [
                  {elements: id}
                ],
                update: {
                  ifc_prop_sets: prop_sets
                }
              });
            }
          });
        });
        // containers
        ['sites', 'spatialzones', 'buildings', 'buildingstoreys', 'spacegroups'].forEach(container => {
          if (object[container]) {
            object[container].forEach(child_id => {
              this.createIFCObjects({
                parent_type: payload.child_type,
                parent_id: object_id,
                child_type: container,
                child_id: child_id,
                ifc_data_object: payload.ifc_data_object,
                ifc_local_placements: payload.ifc_local_placements,
                ifc_property_relations: payload.ifc_property_relations
              });
            });
          }
        });
      });
    },
    ifc_create_path(payload) {
      let paths = [];
      // let identifier = payload.rep.attributes[1];
      let type = payload.rep.attributes[2];
      if (type === "'GeometricCurveSet'") {

        let geometric_curve_sets = payload.rep.attributes[3].map(id => payload.ifc_data_object[id]);
        geometric_curve_sets.forEach(set => {
          let curve_set_items = set.attributes[0].map(id => payload.ifc_data_object[id]);
          curve_set_items.forEach(item => {
            if (item.class === "IFCPOLYLINE") {
              paths.push(this.getPathFromPolyLine({item: item, ifc_data_object: payload.ifc_data_object, trans_matrix: payload.trans_matrix}));
            }
          });
        });
      }
      else if (type === "'Curve2D'") {
        let curves = payload.rep.attributes[3].map(id => payload.ifc_data_object[id]);
        curves.forEach(curve => {
          if (curve.class === 'IFCCOMPOSITECURVE') {
            let segments = curve.attributes[0].map(id => payload.ifc_data_object[id]);
            segments.forEach(segment => {
              let geometry = payload.ifc_data_object[segment.attributes[2]];
              if (geometry.class === 'IFCPOLYLINE') {
                paths.push(this.getPathFromPolyLine({item: geometry, ifc_data_object: payload.ifc_data_object, trans_matrix: payload.trans_matrix}));
              }
            });
          }
        });
      }
      else if (type === "'SweptSolid'") {
        let extruded_areas = payload.rep.attributes[3].map(id => payload.ifc_data_object[id]);
        extruded_areas.forEach(area => {
          let profile = payload.ifc_data_object[area.attributes[0]];
          let area_local_placement_matrix = this.getLocalPlacementMatrices({attributes: [false, area.attributes[1]], ifc_data_object: payload.ifc_data_object});

          // area attributes an 2: extrusions richtung,
          // area attributes an 3: extrusions Länge,


          //area trans matrix ist falsch !!! evtl. anders machen mit punkt setzen
          //Frage tauschen?
          let area_trans_matrix = this.$math.multiply(this.$math.inv(payload.trans_matrix), area_local_placement_matrix.local_matrix);

          let cartesian_point = this.$math.multiply(area_local_placement_matrix.local_matrix[3], payload.trans_matrix);
          area_trans_matrix.splice(3, 1, cartesian_point);


          // let area_trans_matrix = this.$math.multiply(area_local_placement_matrix.local_matrix, this.$math.inv(payload.trans_matrix));
          // let area_trans_matrix = this.$math.multiply(area_local_placement_matrix.local_matrix, this.$math.inv(payload.local_matrix));
          // area_trans_matrix.forEach(col => {
          //   col.splice(col.length-1, 1, 1);
          // });
          //profile types:
          if (profile.class === 'IFCARBITRARYCLOSEDPROFILEDEF') {
            let geometry = payload.ifc_data_object[profile.attributes[2]];
            //geometry types:
            if (geometry.class === 'IFCPOLYLINE') {
              paths.push(this.getPathFromPolyLine({item: geometry, ifc_data_object: payload.ifc_data_object, trans_matrix: area_trans_matrix}));
            }
          } else if (profile.class === 'IFCRECTANGLEPROFILEDEF') {
            let profile_local_placement_matrix = this.getLocalPlacementMatrices({attributes: [false, profile.attributes[2]], ifc_data_object: payload.ifc_data_object});
            //Frage tauschen?
            let profile_trans_matrix = this.$math.multiply(this.$math.inv(area_trans_matrix), profile_local_placement_matrix.local_matrix);

            let cartesian_point = this.$math.multiply(profile_local_placement_matrix.local_matrix[3], area_trans_matrix);
            profile_trans_matrix.splice(3, 1, cartesian_point);


            // let profile_trans_matrix = this.$math.multiply(profile_local_placement_matrix.local_matrix, this.$math.inv(area_local_placement_matrix.local_matrix));
            // profile_trans_matrix.forEach(col => {
            //   col.splice(col.length-1, 1, 1);
            // });
            paths.push(this.getPathFromRectangleProfile({profile: profile, trans_matrix: profile_trans_matrix}));
          }
        });
      }
      return paths;
    },
    getPathFromRectangleProfile(payload) {
      let path = {
        fill: true,
        stroke: true,
        points: [],
        values: []
      };

      let width = payload.profile.attributes[3];
      if (width[width.length-1] === '.') {
        width = width + '0';
      }
      width = parseFloat(width);

      let height = payload.profile.attributes[4];
      if (height[height.length-1] === '.') {
        height = height + '0';
      }
      height = parseFloat(height);

      let p1 = [-width/2, height/2, 0, 1];
      let p2 = [width/2, height/2, 0, 1];
      let p3 = [width/2, -height/2, 0, 1];
      let p4 = [-width/2, -height/2, 0, 1];

      // let p1 = [0, 0, 0, 1];
      // let p2 = [width, 0, 0, 1];
      // let p3 = [width, height, 0, 1];
      // let p4 = [0, height, 0, 1];

      let p1_global = this.$math.multiply(p1, payload.trans_matrix);
      let p2_global = this.$math.multiply(p2, payload.trans_matrix);
      let p3_global = this.$math.multiply(p3, payload.trans_matrix);
      let p4_global = this.$math.multiply(p4, payload.trans_matrix);

      //Frage: kann man y einfach minus sezten?
      path.points.push({method: 'moveTo',x: p1_global[0],y: p1_global[1] * -1, z: 0});
      path.points.push({method: 'lineTo',x: p2_global[0],y: p2_global[1] * -1, z: 0});
      path.points.push({method: 'lineTo',x: p3_global[0],y: p3_global[1] * -1, z: 0});
      path.points.push({method: 'lineTo',x: p4_global[0],y: p4_global[1] * -1, z: 0});

      return path;
    },
    getPathFromPolyLine(payload) {
      let path = {
        fill: true,
        stroke: true,
        points: [],
        values: []
      };
      let points = payload.item.attributes[0].map(id => payload.ifc_data_object[id]);
      points.forEach((point, index) => {
        let x = point.attributes[0][0];
        if (x[x.length-1] === '.') {
          x = x + '0';
        }
        x = parseFloat(x);
        let y = point.attributes[0][1];
        if (y[y.length-1] === '.') {
          y = y + '0';
        }
        y = parseFloat(y);

        let point_vector = [x,y, 0, 1];
        let point_vector_global = this.$math.multiply(point_vector, payload.trans_matrix);

        //Frage: kann man y einfach minus sezten?
        if (index === 0) {
          path.points.push({method: 'moveTo',x: point_vector_global[0],y: point_vector_global[1] * -1, z: 0.0});
        }
        else if (index !== points.length-1 || point.ifc_id !== points[0].ifc_id) {
          path.points.push({method: 'lineTo',x: point_vector_global[0],y: point_vector_global[1] * -1, z: 0});
        }
      });
      return path;
    },
    getLocalPlacementMatrices(payload) {
      let matrices = {
        local_matrix: [],
        trans_matrix: [],
        parent_placement_id: payload.attributes[0],
      };
      // let parent_local_matrix = false;
      //
      // if (payload.attributes[0] !== '$') {
      //   parent_local_matrix = payload.ifc_local_placements[payload.attributes[0]].local_matrix;
      // }

      let axis_placement = payload.ifc_data_object[payload.attributes[1]];
      // if (axis_placement.class === 'IFCAXIS2PLACEMENT3D') {

        let cartesian_point = [0,0,0];
        if (axis_placement.attributes[0] !== '$') {
          cartesian_point = JSON.parse(JSON.stringify(payload.ifc_data_object[axis_placement.attributes[0]].attributes[0]));
          cartesian_point = cartesian_point.map(value => {
            let new_value = value;
            if (new_value[new_value.length-1] === '.') {
              new_value = new_value + '0';
            }
            new_value = parseFloat(new_value);
            // Frage: * -1?
              // if (index === 0) {
                // new_value = new_value * -1;
              // }
            return new_value;
          });
          if (cartesian_point.length < 3) {
            cartesian_point.push(0);
          }
        }

        let z_axis = [0,0,1];
        if (axis_placement.attributes[1] !== '$' && axis_placement.class === 'IFCAXIS2PLACEMENT3D') {
          z_axis = JSON.parse(JSON.stringify(payload.ifc_data_object[axis_placement.attributes[1]].attributes[0]));
          z_axis = z_axis.map(value => {
            let new_value = value;
            if (new_value[new_value.length-1] === '.') {
              new_value = new_value + '0';
            }
            new_value = parseFloat(new_value);
            return new_value;
          });
        }

        let x_axis = [1,0,0];
        if (axis_placement.class === 'IFCAXIS2PLACEMENT3D') {
          if (axis_placement.attributes[2] !== '$') {
            x_axis = JSON.parse(JSON.stringify(payload.ifc_data_object[axis_placement.attributes[2]].attributes[0]));
            x_axis = x_axis.map(value => {
              let new_value = value;
              if (new_value[new_value.length-1] === '.') {
                new_value = new_value + '0';
              }
              new_value = parseFloat(new_value);
              return new_value;
            });
          }
        } else if (axis_placement.attributes[1] !== '$') {
            x_axis = JSON.parse(JSON.stringify(payload.ifc_data_object[axis_placement.attributes[1]].attributes[0]));
            x_axis = x_axis.map(value => {
              let new_value = value;
              if (new_value[new_value.length-1] === '.') {
                new_value = new_value + '0';
              }
              new_value = parseFloat(new_value);
              return new_value;
            });
            x_axis.push(0);
        }

        //Frage! tauschen?
        let y_axis = this.$math.cross(z_axis, x_axis);
        // let y_axis = this.$math.cross(x_axis, z_axis);

        cartesian_point.push(1);
        z_axis.push(0);
        x_axis.push(0);
        y_axis.push(0);

        matrices.local_matrix = [x_axis, y_axis, z_axis, cartesian_point];

        // if (parent_local_matrix === false) {
        //   matrices.trans_matrix = matrices.local_matrix;
        // } else {
        //   matrices.trans_matrix = this.$math.multiply(matrices.local_matrix, this.$math.inv(parent_local_matrix));
        // }

      // }
      return matrices;
    }

  }
};
